import { BiDraftPendingState } from '@euler/app/components/message/widgets/bi-visualization/BiDraftPendingCard';
import { BiCardDataView } from '@euler/app/flows/bi-dashboards/dashboard/functions/useBiCardData';
import { BiVizSpec } from '@euler/model/bi/viz';

/** A gallery page; the value is its URL segment. */
export enum BiGalleryCategoryKey {
  Line = 'line',
  Bar = 'bar',
  HorizontalBar = 'horizontal-bar',
  StackedBar = 'stacked-bar',
  Combo = 'combo',
  Pie = 'pie',
  Radar = 'radar',
  Pyramid = 'pyramid',
  Funnel = 'funnel',
  Table = 'table',
  Kpi = 'kpi',
  Blend = 'blend',
  Formats = 'formats',
  States = 'states',
}

/** A card as a dashboard shows it, in one state of its data. */
export interface BiGalleryDashboardCard {
  surface: 'dashboard';
  title: string;
  viz: BiVizSpec;
  data: BiCardDataView;
  /** Grid rows tall; the dashboard's default for the viz otherwise. */
  rows?: number;
}

/** A chart answer in the chat whose draft has nothing to show. */
export interface BiGalleryChatCard {
  surface: 'chat';
  title: string;
  state: BiDraftPendingState;
}

export type BiGalleryCard = BiGalleryDashboardCard | BiGalleryChatCard;

/** One look of a category: what it sets, and the card showing it. */
export interface BiGalleryVariant {
  key: string;
  name: string;
  /** The options it sets, e.g. `line.smooth = true`. */
  note?: string;
  card: BiGalleryCard;
}

export interface BiGalleryCategory {
  key: BiGalleryCategoryKey;
  name: string;
  description: string;
  /** What the index tile draws. */
  preview: BiGalleryDashboardCard;
  variants: BiGalleryVariant[];
}
